import { client as axios } from "./axiosClient";
import { Constants } from "@socialcoach/services";
import { catchServiceException } from "@socialcoach/services";
import { UserRegistered } from "../interfaces/dtos";
import { PlayerSignUpStep } from ".";

export class LoginStepServices {
  @catchServiceException()
  static async sendPlayerStep(playerSignUpStep: PlayerSignUpStep): Promise<boolean> {
    const response = await axios.put<UserRegistered>(
      `${Constants.API_URL}/accounts/player/step`,
      { playerSignUpStep },
      { withCredentials: true }
    );
    return Promise.resolve(response.status === 200);
  }
}
